module.exports = __webpack_public_path__ + "img/推荐算法系统使用者.d01db999.png";